import React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { Field } from 'factorial-form'

import DaysSelector from 'modules/core/components/Inputs/DaysSelector'
import i18n from 'modules/core/lib/i18n'

import SelectField from './SelectField'
import TextField from './TextField'

const RoleLevel = () => {
  const field = new Field(null, 'string')
  return (
    <Box width="full" gap="s24">
      <Box width="full" gap="s24" flexDirection="row">
        <TextField title={i18n.t('contract_versions.flows.fix.steps.work_hours.hours.label')} />
        <SelectField
          title={i18n.t('contract_versions.flows.fix.steps.work_hours.frequency.label')}
        />
      </Box>

      <Box width="full" gap="s4">
        <Text.Normal size="200" weight="medium" color="grey1000">
          {i18n.t('contract_versions.flows.fix.steps.work_hours.days.label')}
        </Text.Normal>
        <Box paddingX="s24" alignItems="flexStart">
          <DaysSelector readonly field={field} canUnselectAll />
        </Box>
      </Box>

      <TextField
        title={i18n.t('contract_versions.flows.fix.steps.work_hours.max_legal_yearly_hours.label')}
      />
      <TextField
        title={i18n.t('contract_versions.flows.fix.steps.work_hours.maximum_weekly_hours.label')}
      />
    </Box>
  )
}

export default RoleLevel
